import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { Labeled, ReferenceField, Show, SimpleShowLayout, TextField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { notificationsRequests } from "api/notificationsApi";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";

const ShowDepartments = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за структурна единица"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Структурна единица">
              <ReferenceField
                source="structuralUnitId"
                reference={administrationRequests.getStructuralUnitsSelect()}
              >
                <TextField
                  textAlign="center"
                  source="name"
                />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Имейл група">
              <ReferenceField
                source="emailGroupId"
                reference={notificationsRequests.getEmailGroupsSelect()}
              >
                <TextField
                  textAlign="center"
                  source="name"
                />
              </ReferenceField>
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowDepartments;
